import dayjs from 'dayjs';
import { useMemo, useState } from 'react';

import type { Granularity } from '../../models';

export type RangeKey = '3m' | '12m' | 'all';

const DATE_FORMAT = 'YYYY-MM-DD';
// Earliest date we expose for the "all" range (project has no data before this).
const ALL_TIME_START = '2025-01-01';

const computeFrom = (range: RangeKey): string => {
  switch (range) {
    case '3m':
      return dayjs().subtract(90, 'day').format(DATE_FORMAT);
    case 'all':
      return ALL_TIME_START;
    case '12m':
    default:
      return dayjs().subtract(12, 'month').format(DATE_FORMAT);
  }
};

export interface DashboardRange {
  from: string;
  to: string;
  range: RangeKey;
  granularity: Granularity;
  setRange: (range: RangeKey) => void;
  setGranularity: (granularity: Granularity) => void;
}

export const useDashboardRange = (
  defaultRange: RangeKey = '12m',
  defaultGranularity: Granularity = 'week'
): DashboardRange => {
  const [range, setRange] = useState<RangeKey>(defaultRange);
  const [granularity, setGranularity] = useState<Granularity>(defaultGranularity);

  const to = useMemo(() => dayjs().format(DATE_FORMAT), []);
  const from = useMemo(() => computeFrom(range), [range]);

  return { from, to, range, granularity, setRange, setGranularity };
};
